import React, { FC, ReactNode } from 'react';
import { BlurredContent } from './blurred-content';
import { OverlayLabel } from './overlay-label';
import { OverlayContainer } from './styled-components';

// Main Component
interface ComingSoonOverlayProps {
  children: ReactNode;
  label?: string;
}

export const ComingSoonOverlay: FC<ComingSoonOverlayProps> = ({
  children,
  label,
}) => (
  <OverlayContainer>
    <BlurredContent>{children}</BlurredContent>
    <OverlayLabel label={label} />
  </OverlayContainer>
);
